import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { GlobalFooter } from '@nexus/fff-global-footer';

import env from 'utils/env';
import withViewSize from 'HOC/withViewSize/withViewSize';
import GlobalNav from 'shared-components/GlobalNav/GlobalNav';
import styles from './NotFoundPage.module.css';

function ErrorPage({ viewSize }) {
  return (
    <div className={viewSize}>
      <GlobalNav />
      <div className={styles.content}>
        <p className={styles.header}>404</p>
        <p className={styles.paragraph}>
          {"We're sorry, the page you are looking for can't be found."}
        </p>
        <a className={styles.link} href={`https://${env.hostname}`}>
          Go Back Home
        </a>
        <img
          alt="city landscape"
          className={styles.image}
          src="https://static.fabfitfun.com/wp-content/uploads/2019/05/icon-landscape%402x_1558569938.2483_1558569938.4051.png"
        />
      </div>
      <GlobalFooter />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    viewSize: state.viewState.viewSize,
  };
}
export default compose(withViewSize, connect(mapStateToProps))(ErrorPage);
